<template>
  <div id="app">
    <router-view />
    <svg-icon></svg-icon>
  </div>
</template>

<script>
import svgIcon from 'jsapp/widgets/svg'
import existApply from 'baseapp/views/components/existApply'
import { mapActions, mapState, mapGetters } from 'vuex'
export default {
  name: 'app',
  mixins: [existApply],
  data () {
    return {
      timeId: 0
    }
  },

  created () {
    this.getShoppingCartList()
    this.initAppConfig()
    this.getCustomCompanyConfig()
  },
  mounted () {
    this.getUserInfoAction().then((data) => {
      if (data) {
        this.isExistCompanyApply()
      }
    }).catch((error) => {
      this.$log.error('getUserInfoAction' + error)
    })
  },
  computed: {
    ...mapState([
      'isGetWxCode'
    ]),
    ...mapGetters([
      'sellerCompanyid'
    ])
  },

  components: {
    svgIcon
  },

  methods: {
    ...mapActions([
      'getShoppingCartList',
      'getConfig',
      'getSellerConfig',
      'getBuyerMallSkuList',
      'getUserInfoAction',
      'getCustomCompanyConfig'
    ]),
    async initAppConfig () {
      await this.getConfig()
      await this.getSellerConfig(this.sellerCompanyid)
      // if (!this.isGetWxCode) {
      //   wxWrapper.getAuthorizeCode(this.$store.state.config.appid)
      // }
    }
  }
}
</script>

<style lang='less'>
  @import 'src/style/variables.less';
  @import 'src/style/mixins.less';
  html,body{
    height: 100%;
    width: 100%;

    background-color: @el-bg-color;
    font-size: @base-font-size;
    font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
    "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  }
  body {
    .mixin-max-wh();
    margin: 0 auto;
  }
  #app {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/apps/buyerapp/App.vue